import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../../context/AppContext";
import { setJourneyIntent } from "../../../../utils/journeyIntent";
import JourneyPage from "./components/JourneyPage";

const ROBOTRADER_VIDEO_URL = "https://www.youtube.com/@ROBOTRADERAPP/playlists";

export default function MentorWelcome() {
    const { appData, setPageTitle, loggedInUserData } = useAppContext();

    useEffect(() => {
        setPageTitle("Mentor Setup");
        setJourneyIntent({ appId: appData?.id, userData: loggedInUserData, intent: "mentor" });
    }, [appData?.id, loggedInUserData, setPageTitle]);

    const mentorVideos = appData?.metadata?.mentor_videos || {};
    const steps = [
        ["Activate your account", "Pay for access or confirm your active mentor account before managing students.", mentorVideos.activate_account],
        ["Complete your profile", "Add the details students and admins will use to identify your account.", mentorVideos.complete_profile],
        ["Create your first EA", "Set up the expert advisor your students will connect to or purchase access for.", mentorVideos.create_ea],
        ["Generate licences", "Issue licence keys and manage student access from the portal.", mentorVideos.generate_licences],
        ["Track partner activity", "Review earnings, referrals, and withdrawals when affiliate tools are enabled.", mentorVideos.partner_activity],
    ];

    return (
        <JourneyPage
            eyebrow="Mentor onboarding"
            title={`Build your ${appData?.name || "Robotrader"} mentor workspace`}
            subtitle="This path is for EA owners, mentors, signal providers, and account managers who need the full portal."
            primaryAction={{ to: "/account-activation", label: "Activate Account" }}
            secondaryAction={{ to: "/home", label: "Go to Dashboard" }}
        >
            <div className="row g-3">
                {steps.map(([title, description, videoUrl], index) => (
                    <div className="col-md-6" key={title}>
                        <div className="journey-card card custom-card h-100">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-start gap-3 mb-3">
                                    <div className="journey-step-number">{index + 1}</div>
                                    <div>
                                        <h3 className="journey-card-title h5 mb-2">{title}</h3>
                                        <p className="journey-card-copy mb-0">{description}</p>
                                    </div>
                                </div>
                                <a
                                    href={videoUrl || ROBOTRADER_VIDEO_URL}
                                    className="btn btn-outline-primary btn-sm"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <i className="fa fa-play-circle me-2"></i>Watch Video
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
                <div className="col-12">
                    <div className="d-flex flex-wrap gap-2 mt-2">
                        <Link to="/shop" className="btn btn-outline-primary">
                            <i className="fa fa-shopping-bag me-2"></i>View Products
                        </Link>
                        <Link to="/help" className="btn btn-outline-secondary">
                            <i className="fa fa-question-circle me-2"></i>Help Center
                        </Link>
                        <Link to="/welcome" className="btn btn-light">
                            Switch Journey
                        </Link>
                    </div>
                </div>
            </div>
        </JourneyPage>
    );
}
